module.exports = __webpack_public_path__ + "img/imagen10.bbaba2e1.png";